<div class="transcript-content">
  @if (transcript()) {
    @for (entry of transcript()?.entries; track entry) {
      <glxy-transcript-entry [entry]="entry" (contentClicked)="clickedContent($event)"></glxy-transcript-entry>
    }
  } @else {
    @for (item of [1, 2, 3]; track item) {
      <glxy-transcript-entry-loading-state></glxy-transcript-entry-loading-state>
    }
  }
</div>
